import Icon from '@material-ui/icons/People';

import Create from './Create';
import Edit from './Edit';
import List from './List';
import Show from './Show';

export default {
  name: 'user',
  icon: Icon,
  list: List,
  show: Show,
  create: Create,
  edit: Edit,
};
